<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      อัพเดทงานลูกค้า
    </div>
    <div v-if="jobs && jobs.length" class="pt-9">
      <v-card
        v-for="(job, index) in jobs"
        :key="index"
        outlined
        class="pa-2 pb-4"
      >
        <div style="font-weight: 900; font-size: 11px; margin-bottom: 15px">
          JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
        </div>
        <div class="px-3">
          <div style="display: flex; flex-direction: row">
            <!-- <div>
              <img
                style="height: 60px; width: 80px"
                :src="job.customer_profile_pic"
              />
            </div> -->
            <div style="align-self: center; margin-left: 20px; font-size: 10px">
              ชื่อ: {{ job.customer_name }}
            </div>
            <div style="align-self: center; margin-left: 20px; font-size: 10px">
              สถานะ: {{ job.status }}
            </div>
          </div>
          <div style="font-size: 10px; font-weight: bold">
            <div style="font-size: 13px">รายละเอียดงาน</div>
            <div style="line-height: 15px">
              ประเภทงาน: {{ job.work_type }}<br />
              พื้นที่การทาสี: {{ job.work_area }} ตรม<br />
              สถานที่ปฏิบัติงาน: {{ job.customer_address }}
            </div>
          </div>
        </div>

        <div class="px-4">
          <v-btn
            @click="
              active = 'updateprogress';
              dialogData = job;
              showdialog = true;
            "
            class="mt-3"
            small
            color="#14af43"
            outlined
            block
            rounded
            >แจ้งอัพเดทงานลูกค้า
          </v-btn>
          <!-- <v-btn
            @click="
              active = 'history';
              dialogData = job;
              showdialog = true;
            "
            class="mt-3"
            small
            color="#4695da"
            text
            block
            rounded
            >ประวัติแจ้งอัพเดทงาน
          </v-btn> -->
        </div>
      </v-card>
      <v-dialog v-model="showdialog" persistent fullscreen>
        <v-card>
          <v-card-text v-if="active">
            <div class="text-right pa-3 pr-0">
              <v-btn
                @click="
                  active = '';
                  showdialog = false;
                "
                icon
                small
              >
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div v-if="active == 'updateprogress'">
              <UpdateProgessSend
                @onSuccess="onSuccessSend"
                v-model="value"
                :data="dialogData"
              ></UpdateProgessSend>
            </div>
            <div v-if="active == 'history'">
              <UpdateProgessHistory :data="dialogData"></UpdateProgessHistory>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <Nojob></Nojob>
    </div>
  </div>
</template>

<script>
import UpdateProgessSend from "./UpdateProgessSend.vue";
import UpdateProgessHistory from "./UpdateProgessHistory.vue";
import Nojob from "./Nojob.vue";
export default {
  props: ["value"],
  components: {
    UpdateProgessSend,
    UpdateProgessHistory,
    Nojob,
  },
  data() {
    return {
      active: "",
      showdialog: false,
      showHistory: false,
      dialogData: "",
      historyData: "",
    };
  },
  computed: {
    jobs() {
      return this.value.orderlist.filter((el) =>
        ["รอการจัดส่ง", "รอการชำระเงิน", "จัดส่งเรียบร้อย"].includes(el.status)
      );
    },
  },
  methods: {
    onCloseHistory() {
      this.historyData = "";
      this.showHistory = false;
    },
    onSuccessSend(payload) {
      this.dialogData = "";
      this.showdialog = false;
    },
  },
};
</script>